export default __webpack_public_path__ + "static/media/Shell4.c2619207.mp4";